import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
// import contentInfoTracker from '../../components/tracker/contentInfoTracker'
import contentInfoTracker from '@/components/trackerContentInfo/trackerContentInfo'
import contentResumentTracker from '@/components/trackerContentSummary/trackerContentSummary'
import supportCards from '@/components/trackerSupportCard/trackerSupportCard'
import evaluateOrderModal from '@/components/modalEvaluate/modalEvaluate'
import ModalChallenge from '@/components/challengeModal/challengeModal'
import { Getter, State, Mutation, Action } from 'vuex-class'
import Header from '@/components/header/header'

@Component({
  components: {
    contentInfoTracker,
    contentResumentTracker,
    supportCards,
    evaluateOrderModal,
    ModalChallenge,
    Header
  }
})
export default class Tracker extends Vue {
  close = false

  @Getter getUniversity: any
  @Getter getCurrentOrder: any
  @Getter getUser: any

  @State orders: any
  @State university: any
  @State user: any

  @Mutation SHOW_MODAL_CHALLENGE: any
  @Mutation CURRENT_ORDER: any
  @Mutation EVALUATE_ORDER: any
  @Mutation CART_TEMPORAL: any
  @Mutation PSE_ORDER: any
  @Mutation PSE_STATUS: any

  @Action action_getChallengueIns: any
  @Action action_getCurrentOrder: any

  sendToCommerces () {
    this.$router.push({ name: 'restaurant', params: { uni: this.getUniversity.name.split(' ').join() } })
  }
  mounted () {
    this.action_getCurrentOrder(this.$route.params.order_id)
    // Limpiar store del carrito temporal y estado del pedido
    this.CART_TEMPORAL([])
    this.PSE_STATUS(null)
    this.PSE_ORDER(null)
  }
}
